import { Component, Vue } from 'vue-property-decorator'
import CAJG1070Service from './CAJG1070Service'
import CAJG1070ViewModel from './CAJG1070ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import CommonConstants from '@/common/CommonConstants'
import TransportService from '@/common/TransportService'
import CommonUtil from '@/common/utils/CommonUtil'
import { DigitalBookButton } from '@/common/utils/modules-util'
import { fixedContent } from '@/assets/js/main.js'

@Component({
  name: 'CAJG1070',
  components: {}
  })
export default class CAJG1070Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private cajg1070ViewModel: CAJG1070ViewModel = {
    mangaHtmlInfo: {
      content: ''
    }
  }

  private cajg1070Service: CAJG1070Service = new CAJG1070Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$nextTick(() => {
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const [caja1070ResponseModel] = await Promise.all([
      this.cajg1070Service.callAPICAJA1070(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CAJG1070, null, null)
    ])
    if (CommonUtil.isNotEmpty(caja1070ResponseModel.mangaHtmlInfo)) {
      this.cajg1070ViewModel.mangaHtmlInfo.content = CommonUtil.replacePathCMS(
        caja1070ResponseModel.mangaHtmlInfo.content,
        CommonConstants.TEMPLATE_CMS_PATH,
        caja1070ResponseModel.mangaHtmlInfo.path
      )
    } else {
      this.cajg1070ViewModel.mangaHtmlInfo = null
    }
  }

  /**
   * 学習メニュートップ（ログイン後）(CAJG1060 )画面に遷移する。
   */
  private gotoCAJG1060() {
    this.$router.push({ name: 'cajg1060' })
  }
}
